import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function ValueStack() {
  const items = [{
    image: 'https://cdn.magicpatterns.com/uploads/jqwCWHahSZ9Qxis3hEoMKV/portada_de_como_crear_tu_Sistema_.png',
    label: 'Producto Principal',
    title: 'SCORE 700 – Cómo Crear tu Sistema de Crédito en USA (20 Módulos)',
    value: '$49.00'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/nuVUfARUKGq3eMFr4UiEUk/ChatGPT_Image_24_abr_2026,_19_36_33.png',
    label: 'Bono #1',
    title: 'Kit de Herramientas Crediticias',
    value: '$19.99'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/4RceXW5NBDhBwNBpMeeajH/ChatGPT_Image_24_abr_2026,_19_46_34.png',
    label: 'Bono #2',
    title: 'Guía Inteligente para Tarjetas de Crédito en USA',
    value: '$19.99'
  }];
  return <section className="py-24 bg-white" data-id="element-308">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-309">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-310">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-black mb-4" data-id="element-311">
            TODO LO QUE RECIBES HOY
          </h2>
          <div className="w-20 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-312"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-313">
          {items.map((item, index) => <motion.div key={index} className="bg-brand-gray rounded-xl p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border border-gray-100" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.15
        }} data-id="element-314">
              <div className="flex items-center gap-5 flex-1" data-id="element-315">
                <img src={item.image} alt={item.title} className="w-20 sm:w-24 h-auto shrink-0 drop-shadow-lg" data-id="element-316" />
                <div data-id="element-317">
                  <span className="text-brand-gold text-xs font-bold uppercase tracking-wider" data-id="element-318">
                    {item.label}
                  </span>
                  <h4 className="text-brand-black font-bold text-lg leading-tight" data-id="element-319">
                    {item.title}
                  </h4>
                </div>
              </div>
              <span className="text-gray-400 line-through text-lg font-medium whitespace-nowrap" data-id="element-320">
                {item.value}
              </span>
            </motion.div>)}
        </div>

        {/* Total */}
        <motion.div className="mt-8 bg-brand-dark rounded-xl p-8 text-center text-white" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-321">
          <div className="flex flex-col items-center gap-6 mb-6" data-id="element-322">
            <img src="https://cdn.magicpatterns.com/uploads/jqwCWHahSZ9Qxis3hEoMKV/portada_de_como_crear_tu_Sistema_.png" alt="SCORE 700 - Cómo Crear tu Sistema de Crédito en USA" className="w-64 sm:w-72 h-auto drop-shadow-2xl" data-id="element-323" />
            <img src="https://cdn.magicpatterns.com/uploads/nuVUfARUKGq3eMFr4UiEUk/ChatGPT_Image_24_abr_2026,_19_36_33.png" alt="Bono #1: Kit de Herramientas Crediticias" className="w-64 sm:w-72 h-auto drop-shadow-2xl" data-id="element-324" />
            <img src="https://cdn.magicpatterns.com/uploads/4RceXW5NBDhBwNBpMeeajH/ChatGPT_Image_24_abr_2026,_19_46_34.png" alt="Bono #2: Guía Inteligente para Tarjetas de Crédito en USA" className="w-64 sm:w-72 h-auto drop-shadow-2xl" data-id="element-325" />
          </div>
          <p className="text-gray-400 text-sm mb-1" data-id="element-326">Valor total del paquete</p>
          <p className="text-3xl text-gray-400 line-through mb-3" data-id="element-327">$88.98</p>
          <ArrowDown className="w-6 h-6 text-brand-gold mx-auto mb-3" data-id="element-328" />
          <p className="text-brand-gold text-sm font-semibold uppercase tracking-wider mb-2" data-id="element-329">
            Hoy por tiempo limitado
          </p>
          <p className="text-5xl font-bold text-white" data-id="element-330">
            $14<span className="text-3xl" data-id="element-331">.99</span>
          </p>
          <p className="text-gray-400 text-xs mt-3" data-id="element-332">
            Pago único · Sin suscripciones · Acceso de por vida
          </p>

          <motion.button onClick={() => document.getElementById('offer')?.scrollIntoView({
          behavior: 'smooth'
        })} className="mt-6 w-full sm:w-auto px-10 py-4 bg-brand-gold hover:bg-brand-goldHover text-brand-dark rounded-xl font-bold text-lg transition-all shadow-gold hover:shadow-xl hover:-translate-y-1" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} data-id="element-333">
            QUIERO ACCESO INMEDIATO
          </motion.button>
        </motion.div>

        <p className="text-center text-gray-500 text-sm mt-6" data-id="element-334">
          Todo esto en un solo sistema diseñado para ayudarte a tomar el control
          de tu crédito.
        </p>
      </div>
    </section>;
}